<template>
<div>
  <meeting-detail-component></meeting-detail-component>
</div>
</template>

<script>
import meetingDetailComponent from "@/components/meeting/meetingDetailComponent";
export default {
  components:{
    meetingDetailComponent,
  }
}
</script>

<style scoped>

</style>
